// extracted by mini-css-extract-plugin
export default {"root":"styles_root__9quuZ","dragging-over":"styles_dragging-over__JFXRc","draggingOver":"styles_dragging-over__JFXRc","color":"styles_color__0wB3f"};